export default {
    factorXII: {
        title: 'Factor XII',
        description: 'Factor XII starts the <strong>intrinsic pathway</strong>, which begins when an injury occurs and broken skin is exposed. Activated Factor XII goes on to activate Factor XI.'
    },
    factorXI: {
        title: 'Factor XI',
        description: 'Factor XI activates Factor IX, which then activates Factor X.'
    },
    factorIX: {
        title: 'Factor IX',
        description: 'Factor IX helps activate factor X, beginning the <strong>common pathway</strong> to <strong>clot</strong> formation. When the body doesn’t make enough Factor IX, people may have <strong>hemophilia B</strong>.'
    },
    factorVIII: {
        title: 'Factor VIII',
        description: 'Factor VIII helps activate Factor X, beginning the <strong>common pathway</strong> to <strong>clot</strong> formation. When the body doesn’t make enough factor VIII, people may have <strong>hemophilia A</strong>.'
    },
    vonWillebrandFactor: {
        title: 'Von Willebrand factor',
        description: 'Von Willebrand factor (vWF) has two main roles in the body: it binds to Factor VIII, keeping it from being broken down by the body, and it helps <strong>platelets</strong> stick well to the site of injury, forming a strong <strong>platelet plug</strong>. When the body doesn’t make enough vWF, patients may have <strong>von Willebrand disease</strong>.'
    },
    factorX: {
        title: 'Factor X',
        description: 'Factors in the <strong>intrinsic</strong> and <strong>extrinsic pathways</strong> activate Factor X, beginning the <strong>common pathway</strong> to <strong>clot</strong> formation. Factor X helps activate prothrombin into thrombin.'
    },
    factorVIIa: {
        title: 'Factor VIIa',
        description: 'Factor VIIa is one of the most important factors because it triggers both the start of primary <strong>hemostasis</strong> and it is the beginning of the <strong>extrinsic pathway</strong> of the <strong>coagulation cascade</strong>, where it activates factor X.'
    },
    factorVa: {
        title: 'Factor Va',
        description: 'Factor Va, along with activated factor X, activates prothrombin (FII) into thrombin (FIIa).'
    },
    thrombin_IIa: {
        title: 'Thrombin (IIa)',
        description: 'The <strong>coagulation cascade</strong> speeds up when thrombin is formed, creating a "<strong>thrombin burst</strong>." Thrombin causes fibrin to form, which strengthens the clot. The sooner the <strong>thrombin burst</strong> happens, the less damage a bleed can cause.'
    },
    fibrin_Ia: {
        title: 'Fibrin (Ia)',
        description: 'Fibrin acts as a strong net around the <strong>platelet plug</strong> that stabilizes the <strong>clot</strong> and stops bleeding at the site of injury and remains until the injury has healed.'
    },
    factorXIIIa: {
        title: 'Factor XIIIa',
        description: 'Factor XIIIa pulls fibrin strands tightly around the <strong>platelet plug</strong>, further stabilizing the <strong>clot</strong>.'
    },
    clot: {
        title: 'Clot',
        description: 'When the <strong>coagulation cascade</strong> works properly, a fibrin mesh forms around the <strong>platelet plug</strong>, creating a strong, durable <strong>clot</strong>.'
    }
}



// WEBPACK FOOTER //
// ./src/js/text-content/factors-content.js